define("shared/components/shared/post/secondary/saved-captions/editor", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--modalHeader">
    <p class="o--modalHeader__title qa--createSavedCaptions_headerTitle">
      <a class="u--float--left" {{on "click" @exitEditingCaption}}>
        {{svg-jar "arrow-left" class="o--icon--md o--icon--light u--m__r"}}
      </a>
      {{t "posts.template.new.title"}}
    </p>
  </div>
  <section class="o--modalBody--secondary has--footer has--scroll">
    <div class="o--formWrapper">
      <label class="qa--createSavedCaptions_optTitle">
        {{t "posts.template.form_title"}}
      </label>
      <Input
        @value={{@savedCaptionToEdit.title}}
        autofocus={{true}}
        class="o--form__input qa--createSavedCaptions_optTitle_input"
        placeholder={{t "posts.template.form_title_placeholder"}}
      />
    </div>
    <div class="o--formWrapper">
      <label class="qa--createSavedCaptions_title">
        {{t "posts.template.form_caption"}}
      </label>
      <Textarea
        @value={{@savedCaptionToEdit.content}}
        class="o--textareaCaption qa--createSavedCaptionsTitle_textArea"
        disabled={{@savedCaptionToEdit.isSaving}}
        placeholder={{t "posts.template.form_caption_placeholder"}}
      />
    </div>
    {{#each @savedCaptionToEdit.validations.messages as |message|}}
      <span class="o--form__helpText u--text--danger u--float--right">
        {{svg-jar "warning" class="o--icon o--icon--danger u--m__r__xs"}}
        {{message}}
      </span>
    {{/each}}
  </section>
  <div class="o--modalFooter">
    <Shared::Ui::Button
      @isDisabled={{@savedCaptionToEdit.isSaving}}
      @onClick={{fn this.deleteCaption @savedCaptionToEdit}}
      @variant="mute"
      class="u--float--left qa--createSavedCaptions_deleteBtn"
    >
      {{svg-jar "trash" class="o--icon o--icon--light"}}
    </Shared::Ui::Button>
    <Shared::Ui::Button
      @isDisabled={{or (not @savedCaptionToEdit.validations.isValid) @savedCaptionToEdit.isSaving}}
      @onClick={{this.saveCaption}}
      @text={{t "posts.template.save"}}
      @variant="primary"
      class="u--float--right qa--createSavedCaptions_saveBtn"
    />
  </div>
  */
  {
    "id": "+R+8lcPK",
    "block": "[[[10,0],[14,0,\"o--modalHeader\"],[12],[1,\"\\n  \"],[10,2],[14,0,\"o--modalHeader__title qa--createSavedCaptions_headerTitle\"],[12],[1,\"\\n    \"],[11,3],[24,0,\"u--float--left\"],[4,[38,0],[\"click\",[30,1]],null],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"arrow-left\"],[[\"class\"],[\"o--icon--md o--icon--light u--m__r\"]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[1,[28,[35,2],[\"posts.template.new.title\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[10,\"section\"],[14,0,\"o--modalBody--secondary has--footer has--scroll\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n    \"],[10,\"label\"],[14,0,\"qa--createSavedCaptions_optTitle\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"posts.template.form_title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,3],[[16,\"autofocus\",true],[24,0,\"o--form__input qa--createSavedCaptions_optTitle_input\"],[16,\"placeholder\",[28,[37,2],[\"posts.template.form_title_placeholder\"],null]]],[[\"@value\"],[[30,2,[\"title\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n    \"],[10,\"label\"],[14,0,\"qa--createSavedCaptions_title\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"posts.template.form_caption\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,4],[[24,0,\"o--textareaCaption qa--createSavedCaptionsTitle_textArea\"],[16,\"disabled\",[30,2,[\"isSaving\"]]],[16,\"placeholder\",[28,[37,2],[\"posts.template.form_caption_placeholder\"],null]]],[[\"@value\"],[[30,2,[\"content\"]]]],null],[1,\"  \"],[13],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,2,[\"validations\",\"messages\"]]],null]],null],null,[[[1,\"    \"],[10,1],[14,0,\"o--form__helpText u--text--danger u--float--right\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"warning\"],[[\"class\"],[\"o--icon o--icon--danger u--m__r__xs\"]]]],[1,\"\\n      \"],[1,[30,3]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[3]],null],[13],[1,\"\\n\"],[10,0],[14,0,\"o--modalFooter\"],[12],[1,\"\\n  \"],[8,[39,7],[[24,0,\"u--float--left qa--createSavedCaptions_deleteBtn\"]],[[\"@isDisabled\",\"@onClick\",\"@variant\"],[[30,2,[\"isSaving\"]],[28,[37,8],[[30,0,[\"deleteCaption\"]],[30,2]],null],\"mute\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,1],[\"trash\"],[[\"class\"],[\"o--icon o--icon--light\"]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n  \"],[8,[39,7],[[24,0,\"u--float--right qa--createSavedCaptions_saveBtn\"]],[[\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[28,[37,9],[[28,[37,10],[[30,2,[\"validations\",\"isValid\"]]],null],[30,2,[\"isSaving\"]]],null],[30,0,[\"saveCaption\"]],[28,[37,2],[\"posts.template.save\"],null],\"primary\"]],null],[1,\"\\n\"],[13]],[\"@exitEditingCaption\",\"@savedCaptionToEdit\",\"message\"],false,[\"on\",\"svg-jar\",\"t\",\"input\",\"textarea\",\"each\",\"-track-array\",\"shared/ui/button\",\"fn\",\"or\",\"not\"]]",
    "moduleName": "shared/components/shared/post/secondary/saved-captions/editor.hbs",
    "isStrictMode": false
  });
  let EditorComponent = _exports.default = (_class = class EditorComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "segment", _descriptor5, this);
    }
    async deleteCaption(caption) {
      const didConfirm = await this.dialogManager.confirmation(this.intl.t('posts.template.delete.are_you_sure'), {
        confirmButton: this.intl.t('shared_words.delete')
      });
      if (!didConfirm) {
        return;
      }
      try {
        await caption.destroyRecord();
        this.args.setCaptionToEdit(null);
      } catch (error) {
        this.errors.handleAdapter(error);
      }
    }
    async saveCaption() {
      try {
        const caption = this.args.savedCaptionToEdit;
        const captionIsNew = caption.isNew;
        await caption.save();
        if (captionIsNew) {
          this._trackSaveCaptionEvent(caption.title);
        }
        this.args.setCaptionToEdit(null);
      } catch (error) {
        this.errors.handleAdapter(error);
      }
    }
    _trackSaveCaptionEvent(captionTitle) {
      const trackingData = {
        group_id: this.auth.currentGroup.id,
        location: this.args.location,
        saved_caption_title: captionTitle
      };
      this.segment.track('saved-new-caption', trackingData);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "deleteCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "saveCaption"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, EditorComponent);
});